import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ModuleFE_PermissionAccessLevel, ModuleFE_PermissionDomain, ModuleFE_PermissionGroup, } from '@nu-art/permissions-frontend/index';
import { LL_V_L, SimpleListAdapter, TS_DropDown, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { Component_UserTypeInfo } from '../components/Component_UserTypeInfo.js';
import { PermissionGroupData_All } from '@app/shared/permissions/permission-groups';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
export class Component_UserPermissions extends TS_EditableItemComponentProto {
    ddCarets = {
        open: _jsx(ICONS.advisorArrowDown.component, { className: 'open' }),
        close: _jsx(ICONS.advisorArrowDown.component, { className: 'close' }),
    };
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.user = nextProps.user;
        return state;
    }
    // ######################## Logic ########################
    setGroup = async (groupId) => {
        //Clear all other group ids from user
        const user = this.state.editable;
        const permissionGroupDataIds = PermissionGroupData_All.map(i => i._id);
        const groups = user.item.groups?.filter(group => !permissionGroupDataIds.includes(group.groupId)) ?? [];
        groups.push({ groupId });
        try {
            await user.updateObj({ groups });
        }
        catch (err) {
            this.logError(err);
        }
    };
    getSelectedPermissionGroup = () => {
        return PermissionGroupData_All.find(group => this.state.editable.item.groups?.find(_group => _group.groupId === group._id));
    };
    // ######################## Render ########################
    renderHCSAccess = () => {
        const adapter = SimpleListAdapter(PermissionGroupData_All, i => _jsx(_Fragment, { children: i.item.name }));
        const selectedGroupData = this.getSelectedPermissionGroup();
        const selectedPermissionGroup = ModuleFE_PermissionGroup.cache.unique(selectedGroupData?._id);
        if (selectedGroupData && !selectedPermissionGroup)
            throw new MUSTNeverHappenException(`Could not get permission group for id ${selectedGroupData._id}`);
        return _jsxs(LL_V_L, { className: 'match_width', style: { gap: '8px' }, children: [_jsxs(TS_PropRenderer.Horizontal, { label: 'Knowledge Manager Access', className: 'user-permissions__role', children: [_jsx(Component_UserTypeInfo, { scope: 'knowledgeManager' }), _jsx(TS_DropDown, { adapter: adapter, selected: selectedGroupData, onSelected: item => this.setGroup(item._id), caret: this.ddCarets })] }), selectedPermissionGroup && selectedPermissionGroup.accessLevelIds.map(accessLevelId => {
                    const accessLevel = ModuleFE_PermissionAccessLevel.cache.unique(accessLevelId);
                    if (!accessLevel)
                        throw new MUSTNeverHappenException(`Could not get access level for id ${accessLevelId}`);
                    const domain = ModuleFE_PermissionDomain.cache.unique(accessLevel.domainId);
                    if (!domain)
                        throw new MUSTNeverHappenException(`Could not get domain for id ${accessLevel.domainId}`);
                    return _jsx(TS_PropRenderer.Horizontal, { label: domain.namespace, children: accessLevel.name }, domain._id);
                })] });
    };
    render() {
        return _jsx("div", { className: 'user-permissions', children: this.renderHCSAccess() });
    }
}
